/** 邮箱注册：字母开头；仅字母、数字、下划线、横线、英文句号 */
export const USERNAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9_.-]*$/

export function isValidUsername(value) {
  return typeof value === 'string' && USERNAME_PATTERN.test(value)
}

export const USERNAME_HINT =
  '用户名须以字母开头，仅可包含字母、数字、下划线（_）、横线（-）或英文句号（.）'

/** 微信默认用户名修改：至少 8 位，字母数字及 _ . - */
export const WECHAT_USERNAME_PATTERN = /^[a-zA-Z0-9._-]{8,32}$/

export const WECHAT_USERNAME_MIN_LEN = 8
export const WECHAT_USERNAME_MAX_LEN = 32

export const WECHAT_USERNAME_HINT =
  '用户名至少 8 位，仅可包含字母、数字、下划线（_）、横线（-）或英文句号（.），不得含有侮辱、犯罪等不当含义'

export function isValidWechatUsernameChange(value) {
  return typeof value === 'string' && WECHAT_USERNAME_PATTERN.test(value.trim())
}

export function isAutoGeneratedUsername(username) {
  if (!username || typeof username !== 'string') return false
  const name = username.trim()
  if (/^wx_[a-zA-Z0-9]{10,29}$/.test(name)) return true
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{6}$/.test(name)) return true
  return false
}
